<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
    created(){
        // var new_element = document.createElement("script");
        // new_element.setAttribute("type", "text/javascript");
        // new_element.setAttribute(
        // "src",
        // "https://g.alicdn.com/code/lib/vConsole/3.4.0/vconsole.min.js"
        // );
        // document.body.appendChild(new_element);
        // window.onload = function () {
        // let vConsole = new window.VConsole();
        // console.log(vConsole);
        // };
    },
    methods: {
        
    // 分享
    // share() {
    //   //微信jsdk
    //   let script = document.createElement("script");
    //   script.src =
    //     "https://api.xiaoxxx.com/weixin/getJssdkConfig?callback=callback&url=https://h5case3.xiaoxxx.cn/202105/quark-answer/dist/index.html";
    //   document.body.appendChild(script);
    //   window.callback = (res) => {
    //     console.log(res.data);
    //     window.wx.config({
    //       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //       appId: res.data.appId, // 必填，公众号的唯一标识
    //       timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    //       nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
    //       signature: res.data.signature,
    //       jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
    //     });
    //   };
    //   // 微信分享
    //   window.wx.ready(() => {
    //     // 分享好友
    //     window.wx.updateAppMessageShareData({
    //       title: "测测你的高考剩余值", // 分享标题
    //       desc: "如果重返高考考场，你到底还能拿多少分呢？", // 分享描述
    //       link: "https://h5case3.xiaoxxx.cn/202105/quark-answer/dist/index.html", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //       imgUrl:
    //         "https://h5case3.xiaoxxx.cn/202105/quark-answer/src/assets/fx.jpg", // 分享图标
    //       success: function () {
    //         // 设置成功
    //         // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数','1','1']);
    //       },
    //     });
    //     // 分享朋友圈
    //     window.wx.updateTimelineShareData({
    //       title: "测测你的高考剩余值", // 分享标题
    //       link: "https://h5case3.xiaoxxx.cn/202105/quark-answer/dist/index.html", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //       imgUrl:
    //         "https://h5case3.xiaoxxx.cn/202105/quark-answer/src/assets/fx.jpg", // 分享图标
    //       success: function () {
    //         // 设置成功
    //         // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享朋友圈次数', '分享朋友圈次数','1','1']);
    //       },
    //     });
    //   });

    //   // 钉钉分享
    //   window.dd.ready(function () {
    //     window.dd.biz.navigation.setRight({
    //       show: true,
    //       control: true,
    //       text: "分享",
    //       onSuccess: function () {
    //         window.dd.biz.util.share({
    //           type: 0, //分享类型，0:全部组件 默认；1:只能分享到钉钉；2:不能分享，只有刷新按钮
    //           url: "https://h5case3.xiaoxxx.cn/202105/quark-answer/dist/index.html",
    //           title: "测测你的高考剩余值",
    //           content: "如果重返高考考场，你到底还能拿多少分呢？",
    //           image:
    //             "https://h5case3.xiaoxxx.cn/202105/quark-answer/src/assets/fx.jpg",
    //           onSuccess: function () {},
    //           onFail: function () {},
    //         });
    //       },
    //     });
    //   });
    // },
  },
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
html,
body,
div,
ul,
input,
li,
p {
  margin: 0;
  padding: 0;
}
img{
  border: none;
}
html,
body {
  width: 100%;
  height: 100%;
}
.el-scrollbar {
    > .el-scrollbar__bar {
        opacity: 1 !important;
    }
}
@font-face {
    font-family: huakang;
    src: url('./assets/huakanghaibaoti.ttf');
}
@font-face {
    font-family: siyuan;
    src: url('./assets/SourceHanSansCN-Regular.otf');
}
</style>
